import { createContext, ReactNode, useReducer } from "react";

type Props = {
    children?: ReactNode;
};

export type InitialType = {
    user: {
        id: number | string,
        username: string,
        type: string,
        uuid: string,
        token: string,
    } | null
    loading: boolean
};
interface AuthContextType {
    state: InitialType;
    dispatch: React.Dispatch<Action>;
}

export type Action = {
    type: ActionType;
    payload?: any;
};

export enum ActionType {
    SET_USER = 'SET_USER',
    SET_LOADING = 'SET_LOADING'
}
const initialState = {
    user: null,
    loading: false
}
let AuthContext = createContext<AuthContextType>({ state: initialState, dispatch: () => { } });

const AuthProvider = ({ children }: Props) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    return <AuthContext.Provider value={{ state, dispatch }}>{children}</AuthContext.Provider>;
}
export { AuthContext, AuthProvider }

const reducer = (state: InitialType, action: Action) => {
    switch (action.type) {
        case ActionType.SET_USER:
            return { ...state, user: action.payload, loading: false }
        case ActionType.SET_LOADING:
            return {...state, loading:action.payload}
        default:
            return state;
    }
}
